import { render } from "./VendorInvoiceOffers.vue?vue&type=template&id=43058934&ts=true"
import script from "./VendorInvoiceOffers.vue?vue&type=script&lang=ts"
export * from "./VendorInvoiceOffers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__